module.exports = __webpack_public_path__ + "img/snippets.6bc199e3.webp";